import React from "react";

import "./styles.scss";

import { Container, Row, Col } from "reactstrap";
import IconPlus from "../../../../components/Icons/IconPlus";

const OurCourses = () => {
    const courses = [
        {
            title: 'Diplomatura en Marketing y Comunicación Deportiva',
            description: 'Encuentra aquí todos los detalles sobre nuestra Diplomatura en Marketing y Comunicación Deportiva',
            class: 'MKT-COMU',
            link: '/diplomado-en-marketing-y-comunicacion'
        },
        {
            title: 'Máster de Dirección Deportiva',
            description: 'Encuentra aquí todos los detalles sobre nuestro Máster de Dirección Deportiva.',
            class: 'DIR-DEP',
            link: '/master-de-direccion-deportiva'
        },
        {
            title: 'Finanzas y Gestión para Deportistas',
            description: 'Encuentra aquí todos los detalles sobre nuestro programa introductorio en Finanzas y Gestión para Deportistas.',
            class: 'FIN-GES',
            link: '/programa-introductorio-en-finanzas-y-gestion-para-deportistas'
        },
    ];

    return (
        <Container fluid tag="section" className="our-courses py-5">
            <Row className="pb-5">
                <Col xs="12" className="text-center">
                    <h2 className="title">Nuestros cursos</h2>
                </Col>
                {courses.map((course, i) => (
                    <Col tag="article" lg="6" xl="4" key={i} className="mt-5">
                        <div className="card card-hover-flip">
                            <div className="card-content">
                                <div className={`card-front ${course.class}`}>
                                    <h4>{course.title}</h4>
                                </div>
                                <div className={`card-back ${course.class}`}>
                                    <p>{course.description}</p>
                                    <a href={course.link}><IconPlus width="15" height="15" /> VER MÁS</a>
                                </div>
                            </div>
                        </div>
                    </Col>
                ))}
            </Row>
        </Container>
    );
};

export default OurCourses;